/*
  Итог загрузки выписки - §3.10.2.

  Вынесен из `StatementUpload` 20.10.2026, когда шаг перешёл на путь «файл один
  раз» (решение владельца 19.10.2026) и упёрся в норму компонента. Удачный
  конец с этого дня - зелёный блок «Готово» (`UploadEnd`, вариант А макета):
  цифры в ряд, время записи и следующие шаги. Прежняя карточка «Что получилось»
  называла те же цифры списком и ушла вместе с ним; строки, которые не удалось
  прочитать, остались под блоком.

  Пропущенные строки названы числом и после этой правки: списаний в выписке
  организации столько же, сколько поступлений, и молчаливый пропуск неотличим
  от потери данных (решение 10.09.2026).
*/

import { Notice } from './Common.jsx'
import UploadEnd from './upload/UploadEnd.jsx'

export default function StatementOutcome({ outcome, seconds = null, onAgain = null }) {
  if (outcome.status === 'failed') {
    return (
      <section className="section">
        <Notice kind="error" wide>
          {outcome.error_message}
        </Notice>
      </section>
    )
  }

  return (
    <section className="section">
      <UploadEnd
        title="Готово: поступления разнесены по счетам"
        facts={[
          ['Принято поступлений', outcome.rows_accepted],
          ['Из них новых', outcome.rows_new],
          ['Пропущено строк', outcome.rows_skipped],
          ['Ждут вашего разбора', outcome.needs_attention],
        ]}
        advice="Пропущенные строки - это списания, итоги оборотов и пустые строки. Поступления, которые Арбитр ЖКХ не разнёс сам, ждут вас ниже, в разделе «Требуют вашего разбора»."
        seconds={seconds}
        onAgain={onAgain}
      />
      {outcome.issues.length > 0 ? (
        <div className="card">
          <h3 className="section__subtitle">Строки, которые не удалось прочитать</h3>
          <ul className="list">
            {outcome.issues.map((issue) => (
              <li key={`${issue.row_number}-${issue.reason}`}>
                Строка {issue.row_number}: {issue.explanation}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  )
}
